import type { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './ChartCard.module.scss';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  controls?: ReactNode;
  onRemove?: () => void;
  footer?: ReactNode;
  className?: string;
}

export const ChartCard = ({
  title,
  subtitle,
  children,
  controls,
  onRemove,
  footer,
  className,
}: ChartCardProps) => (
  <section className={classNames(styles.card, className)} aria-label={title}>
    <header className={classNames(styles.header, 'widget-drag-handle')}>
      <div className={styles.titles}>
        <h3 className={styles.title}>{title}</h3>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      <div className={classNames(styles.tools, 'widget-no-drag')}>
        <span className={styles.grip} aria-hidden="true" title="Drag to move">
          ⋮⋮
        </span>
        {onRemove ? (
          <button
            type="button"
            className={styles.remove}
            onClick={onRemove}
            aria-label={`Remove ${title}`}
          >
            ×
          </button>
        ) : null}
      </div>
    </header>
    {controls}
    <div className={styles.body}>{children}</div>
    {footer ? <footer className={styles.footer}>{footer}</footer> : null}
  </section>
);
